export { default } from './DNSFilter.data';
